export default __webpack_public_path__ + "static/media/P10006.f58792f6.png";